var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTypesofcolleges(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 4.0835V12.2502",
    stroke: "#1D4ED8",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.74996 10.5C1.59525 10.5 1.44688 10.4385 1.33748 10.3291C1.22808 10.2197 1.16663 10.0714 1.16663 9.91667V2.33333C1.16663 2.17862 1.22808 2.03025 1.33748 1.92085C1.44688 1.81146 1.59525 1.75 1.74996 1.75H4.66663C5.28546 1.75 5.87896 1.99583 6.31654 2.43342C6.75413 2.871 6.99996 3.46449 6.99996 4.08333C6.99996 3.46449 7.24579 2.871 7.68338 2.43342C8.12096 1.99583 8.71445 1.75 9.33329 1.75H12.25C12.4047 1.75 12.553 1.81146 12.6624 1.92085C12.7718 2.03025 12.8333 2.17862 12.8333 2.33333V9.91667C12.8333 10.0714 12.7718 10.2197 12.6624 10.3291C12.553 10.4385 12.4047 10.5 12.25 10.5H8.74996C8.28583 10.5 7.84071 10.6844 7.51252 11.0126C7.18433 11.3408 6.99996 11.7859 6.99996 12.25C6.99996 11.7859 6.81558 11.3408 6.4874 11.0126C6.15921 10.6844 5.71409 10.5 5.24996 10.5H1.74996Z",
    stroke: "#1D4ED8",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypesofcolleges);
export default __webpack_public_path__ + "static/media/types of colleges.f3acfe4528a4b9247c416a2f38323741.svg";
export { ForwardRef as ReactComponent };